import { Component } from "preact";
import { connect } from "react-redux";
import { Field, reduxForm, change } from "redux-form";
import Button from "../../../components/Button";
import InputField from "../../../components/fields/InputField";
import { updateAttendeeProfilePublic } from "../../../state/actions/attendeeProfileActions";
import { email, required } from "../../../utils/Validators";
import Modal from "../../../components/Modal";
const formName = "existingAttendeeProfile";
class AttendeeProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editing: false,
      modalOpen: false,
      showExtraInfo: false
    };
  }

  save = profileData => {
    const { updateAttendeeProfilePublic, routeParams } = this.props;
    updateAttendeeProfilePublic(routeParams, profileData);
    this.setState({ editing: false });
  };

  cancel = cb => {
    this.setState({ editing: false }, cb);
  };

  enableEditing = () => {
    this.setState({ editing: true });
  };

  openReassigningInfo = () => {
    this.setState({ modalOpen: true });
  };

  render({ attendeeProfile }) {
    const { editing, showExtraInfo } = this.state;
    const { profile } = attendeeProfile;
    return (
      <div>
        <h2>Attendee Profile</h2>
        {attendeeProfile.loading ? (
          <div class="loading loading-lg" />
        ) : (
          <AttendeeForm allowEdit={editing} />
        )}
        <div style={{ display: "flex" }}>
          <div style={{ flexGrow: 1 }}>
            {editing ? (
              <CancelButton onClick={this.cancel} profile={profile} />
            ) : (
              <Button
                type="secondary"
                ariaLabel="cancel"
                onClick={() => {
                  this.setState({ showExtraInfo: true });
                }}
              >
                Re-assign tickets
              </Button>
            )}
          </div>
          {editing ? (
            <SaveButton saveDetails={this.save} />
          ) : (
            <Button
              value="Edit"
              type="primary"
              ariaLabel="edit"
              onClick={this.enableEditing}
            >
              Edit
            </Button>
          )}
        </div>
        {showExtraInfo ? (
          <ExtraInfoModal
            showModal={showExtraInfo}
            onClose={() => this.setState({ showExtraInfo: false })}
          />
        ) : null}
      </div>
    );
  }
}

let AttendeeForm = ({ allowEdit }) => {
  return (
    <form style={{ padding: 20 }} id={formName}>
      <Field
        label="First Name"
        type="text"
        name={`firstName`}
        component={InputField}
        required={true}
        validate={[required]}
        disabled={!allowEdit}
      />
      <Field
        label="Last Name"
        type="text"
        name={`lastName`}
        component={InputField}
        required={true}
        validate={[required]}
        disabled={!allowEdit}
      />
      <Field
        label="Email"
        type="text"
        name={`email`}
        component={InputField}
        required={true}
        validate={[required, email]}
        autocomplete="email"
        disabled={true}
      />
    </form>
  );
};

const ExtraInfoModal = ({ onClose, showModal }) => {
  return (
    <Modal
      showModal={showModal}
      closeHandler={onClose}
      destroy={false}
      padding={48}
    >
      <p>
        Only the buyer can re-assign tickets. If you wish some or all of your
        tickets to be transfered please contact the buyer.
      </p>
    </Modal>
  );
};

let SaveButton = ({ handleSubmit, saveDetails }) => {
  return (
    <Button
      buttonType="submit"
      form={formName}
      ariaLabel="submit"
      value="Submit"
      type="primary"
      onClick={handleSubmit(saveDetails)}
    >
      Save
    </Button>
  );
};

let CancelButton = ({ reset, onClick, dispatch, profile }) => {
  const { firstName, lastName, email } = profile;
  const changeFieldValue = (field, value) => {
    dispatch(change(formName, field, value));
  };
  return (
    <Button
      type="secondary"
      ariaLabel="cancel"
      onClick={() => {
        // We need to explicitly set the fields again on cancel
        // Because redux form thinks its a good idea to destory the default data
        // when the field is set to disabled
        if (onClick) {
          onClick(() => {
            changeFieldValue("firstName", firstName);
            changeFieldValue("lastName", lastName);
            changeFieldValue("email", email);
          });
        }
      }}
    >
      Cancel
    </Button>
  );
};

CancelButton = reduxForm({
  form: formName
})(CancelButton);

SaveButton = reduxForm({
  form: formName
})(SaveButton);

AttendeeForm = reduxForm({
  form: formName,
  destroyOnUnmount: true,
  enableReinitialize: true,
  onSubmitFail: errors => {
    scrollToErrors();
  }
})(AttendeeForm);

AttendeeForm = connect((state, ownProps) => {
  return {
    initialValues: state.attendeeProfile.profile
  };
})(AttendeeForm);

export default connect(
  state => {
    return {
      attendeeProfile: state.attendeeProfile
    };
  },
  { updateAttendeeProfilePublic }
)(AttendeeProfile);



// WEBPACK FOOTER //
// ./routes/public/editTicket/AttendeeProfile.js